import Movie1 from '../assets/movie1.webp';
import Movie2 from '../assets/movie2.jpeg';
import Movie3 from '../assets/movie3.webp';
import Movie4 from '../assets/movie4.webp';
import Thumbnail1 from '../assets/thumbnail1.jpeg';
import Thumbnail2 from '../assets/thumbnail2.jpeg';
import Thumbnail3 from '../assets/thumbnail3.jpeg';
import Thumbnail4 from '../assets/thumbnail4.jpeg';
import Verified from '../assets/verified.svg';
export const movies = [
  {
    id: 0,
    image: Movie1,
    thumbnail: Thumbnail1,
    title: 'Wednesday: Thing released in the streets of New York City',
    author: 'Netflix',
    viewCount: '1.3M views',
    moment: '1 day ago',
    verified: Verified,
    subscribers: '1.2M subscribers',
    subscribed: true,
    username: '@netflix',
    videos: [{
      image: Movie2,
      title: 'How to add a movie',
      viewCount: '4.1k views',
      moment: '1 day ago'
    },
    {
      image: Movie4,
      title: 'Jump scare',
      viewCount: '2.1k views',
      moment: '2 weeks ago'
    },
    {
      image: Movie3,
      title: 'How to add a movie',
      viewCount: '4.1k views',
      moment: '1 month ago'
    }],
    description: `Take a look at how Wednesday brought to life our beloved limb. 

    ➡️SUBSCRIBE FOR MORE: http://bit.ly/29kBByr
    
    About Netflix:
    Netflix is the world's leading streaming entertainment service with 223 million paid memberships in over 190 countries enjoying TV series, documentaries, feature films and mobile games across a wide variety of genres and languages. Members can play, pause and resume watching as much as they want, anytime, anywhere, and can change their plans at any time.
    
    Thing: Behind The Scenes | Wednesday | Netflix
    https://www.youtube.com/@stillwatchin...
    
    Smart, sarcastic and a little dead inside, Wednesday Addams investigates a murder spree while making new friends — and foes — at Nevermore Academy.`
  },
  {
    id: 1,
    image: Movie2,
    thumbnail: Thumbnail2,
    title: 'Beyond the seas',
    author: 'Chained Pacer',
    viewCount: '88k views',
    moment: '1 year ago',
    subscribers: '250k subscribers',
    subscribed: true,
    username: '@chained',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
  {
    id: 2,
    image: Movie3,
    thumbnail: Thumbnail3,
    title: 'My NYSC experience in Kebbi',
    author: 'Paulina Mclair',
    viewCount: '200 views',
    moment: '6 months ago',
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@stoner',
    description: `song: Bad Guy
    artist: Billie Eilish
    show: Wednesday
    
    I didn't really like the show except from the character Wednesday because in my opinion it was a bit childish and maybe it was just meant for little kids but that's just my opinion...
    
    let me know what you thought about the show :))
    
    I had to include the dance scene because Jenna Ortega KILLED IT
    
    
    
    
    #wednesday #wednesdayaddams #badguy #billieeilish #jennaortega`
  },
  {
    id: 3,
    image: Movie4,
    thumbnail: Thumbnail4,
    title: 'Iya Tao reloaded: Teni in trouble after slapping Brother Tayo',
    author: 'Taooma',
    viewCount: '869k views',
    moment: '3 weeks ago',
    verified: Verified,
    subscribers: '480k subscribers',
    subscribed: true,
    username: '@IyaTao',
    description: `The worldwide phenomenon comes to life in Fifty Shades of Grey, starring Dakota Johnson and Jamie Dornan in the iconic roles of Anastasia Steele and Christian Grey. Ana is an inexperienced college student tasked with interviewing enigmatic billionaire Christian Grey. But what starts as business quickly becomes an unconventional romance. Swept up in Christian's glamorous lifestyle, Ana soon finds another side to him as she discovers his secrets and explores her own dark desires. What results is a thrilling, all-consuming romance as Christian and Ana test the limits they will go to for their relationship.

    Own it now on 4K Ultra HD, Blu-ray, DVD & Digital: https://www.uphe.com/movies/fifty-sha...
    
    Sign-up to receive updates, sneak peeks and offers here: http://uni.pictures/emailyt `
  },
  {
    id: 4,
    image: Movie1,
    thumbnail: Thumbnail1,
    title: 'Wednesday: Thing released in the streets of New York City',
    author: 'Netflix',
    viewCount: '1.3M views',
    moment: '1 day ago',
    verified: Verified,
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@netflix',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `

  },
  {
    id: 5,
    image: Movie2,
    thumbnail: Thumbnail2,
    title: 'Beyond the seas',
    author: 'Chained Pacer',
    viewCount: '88k views',
    moment: '1 year ago',
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@pacer',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
  {
    id: 6,
    image: Movie3,
    thumbnail: Thumbnail3,
    title: 'My NYSC experience in Kebbi',
    author: 'Paulina',
    viewCount: '200 views',
    moment: '6 months ago',
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@wednesday',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
  {
    id: 7,
    image: Movie4,
    thumbnail: Thumbnail4,
    title: 'Iya Tao reloaded',
    author: 'Taooma',
    viewCount: '869k views',
    moment: '3 weeks ago',
    verified: Verified,
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@wondergirl',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
  {
    id: 8,
    image: Movie1,
    thumbnail: Thumbnail1,
    title: 'Wednesday: Thing released in the streets of New York City',
    author: 'Netflix',
    viewCount: '1.3M views',
    moment: '1 day ago',
    verified: Verified,
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@trialed',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
  {
    id: 9,
    image: Movie2,
    thumbnail: Thumbnail2,
    title: 'Beyond the seas',
    author: 'Chained Pacer',
    viewCount: '88k views',
    moment: '1 year ago',
    subscribers: '480k subscribers',
    subscribed: true,
    username: "@2chained",
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
  {
    id: 10,
    image: Movie3,
    thumbnail: Thumbnail3,
    title: 'My NYSC experience in Kebbi',
    author: 'Paulina',
    viewCount: '200 views',
    moment: '6 months ago',
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@destinygirl',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
  {
    id: 11,
    image: Movie4,
    thumbnail: Thumbnail4,
    title: 'Iya Tao reloaded',
    author: 'Taooma',
    viewCount: '869k views',
    moment: '3 weeks ago',
    verified: Verified,
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@tao',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  }, {
    id: 12,
    image: Movie3,
    thumbnail: Thumbnail3,
    title: 'My NYSC experience in Kebbi',
    author: 'Paulina',
    viewCount: '200 views',
    moment: '6 months ago',
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@aaron123',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
  {
    id: 13,
    image: Movie2,
    thumbnail: Thumbnail2,
    title: 'Beyond the seas',
    author: 'Chained Pacer',
    viewCount: '88k views',
    moment: '1 year ago',
    subscribers: '480k subscribers',
    subscribed: false,
    username: '@livid',
    description: `These were extremely hard not to look away from! Hope you
    enjoyed though!
    
    If you did please LIKE the video and SUBSCRIBE for
    more weird/funny/slightly entertaining content!

    `
  },
];